import { BackendError, BasketCustomerOrderEntity, Service } from '@genial/services';
import { ResponsesBasketCustomerOrderResponse } from '@genial/services/dist/models';
import { selectorFamily } from 'recoil';

import { BasketAdvisorListDataItem } from '../../pages/BatchTicket/utils/types';
import { normalizeBasketAdvisorOrderData } from '../batchTicket/normalize';
import { advisorIdToApisSelector, partnerIdToApisSelector } from '../master/selector';

import { screenName } from './constants';

export const batchTicketCustomerBasketAdvisorDetailsQuery = selectorFamily<
  | {
      data: ResponsesBasketCustomerOrderResponse[];
    }
  | undefined,
  { basketAdvisorId: string; skip?: boolean }
>({
  key: 'batchTicketDetail/batchTicketCustomerBasketAdvisorDetailsQuery',
  get:
    ({ basketAdvisorId, skip }) =>
    async () => {
      if (skip) {
        return undefined;
      }
      try {
        const { data } = await Service.Basket.V1.getAllCustomerBasketAdvisor({
          screenName,
          basketAdvisorId,
        });

        const normalizedData = data || [];

        return { data: normalizedData };
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return { data: [] };
        }

        throw error;
      }
    },
});

export const batchTicketCustomerBasketDetailsQuery = selectorFamily<
  | {
      data: BasketAdvisorListDataItem;
    }
  | undefined,
  { basketAdvisorOrderId: string; skip?: boolean }
>({
  key: 'batchTicketDetail/batchTicketCustomerBasketDetailsQuery',
  get:
    ({ basketAdvisorOrderId, skip }) =>
    async ({ get }) => {
      if (skip) {
        return undefined;
      }
      const advisorSelected = get(advisorIdToApisSelector);
      const partnerSelected = get(partnerIdToApisSelector);

      const { data } = await Service.Basket.V1.getBasketAdvisorByDetails({
        screenName,
        basketAdvisorOrderId,
        advisorId: advisorSelected,
        partnerId: partnerSelected,
      });

      const normalizedData = normalizeBasketAdvisorOrderData({
        ...data.basketAdvisorOrder,
        totalBasketDeliveredAmount: data.totaBasketDeliveredAmount,
        totalBasketDeliveredOffers: data.totaBasketDeliveredOffers,
        totalBasketDeliveredCustomers: data.totaBasketDeliveredCustomers,
      });

      return { data: { ...normalizedData, requestUserFullName: data?.requestUserFullName } };
    },
});

export const batchTicketCustomerBasketOrderDetailsQuery = selectorFamily<
  | {
      data: BasketCustomerOrderEntity;
    }
  | undefined,
  { basketCustomerId: string }
>({
  key: 'batchTicketDetail/batchTicketCustomerBasketOrderDetailsQuery',
  get:
    ({ basketCustomerId }) =>
    async () => {
      const { data } = await Service.Basket.V1.getBasketCustomerByBasketCustomerId({
        screenName,
        basketCustomerId,
      });

      const normalizedData = data.basketCustomerOrder;

      return { data: normalizedData };
    },
});
